import React from 'react'
import { useAppSelector } from '../../../../../hooks/redux'
import { Divider, useTheme } from '@mui/material'

import MediaAvatar from '../../../../atoms/MediaAvatar'

import { selectPresence } from '../../../../../slices/presence'
import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'

type PersonalSpaceBeginningProps = {
  name: string
  user: APIUser
}
const PersonalSpaceBeginning: React.FC<PersonalSpaceBeginningProps> = ({
  name,
  user
}) => {
  const theme = useTheme()

  const { presence } = useAppSelector(selectPresence)

  const { isSmall } = useBreakpoint()

  const [pres, setPres] = React.useState(false)

  const classes = useStyles({ smallMedia: isSmall, pres })

  React.useEffect(() => {
    if (user) {
      const status = presence[user.id]
      setPres(status)
    }
  }, [user, presence])

  return (
    <div className={classes.container}>
      <div className={classes.avatarArea}>
        <MediaAvatar user={user} />
        <span className={classes.avatarName}>{name}</span>
      </div>

      <div className={classes.message}>
        This is{' '}
        {
          <span style={{ fontWeight: theme.bold.bold }}>
            your personal space
          </span>
        }
        . Use this for drafts, notes, reminders, or send files to yourself.
      </div>
      <Divider />
    </div>
  )
}

export default PersonalSpaceBeginning
